<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li *ngIf="detailUser?.length<=0"><a routerLink="/">Home</a></li>
                <li *ngIf="detailUser"><a routerLink="/elenco-corsi/i-miei-corsi">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="courses-details-image d-none">
    <img  src="assets/img/university-contatti.jpg"  style="max-height:550px; width:100%; object-fit: cover;  object-position: bottom bottom;" alt="image">
</div>

<div id="map">
    <iframe src="https://maps.google.com/maps?q=Ansi formazione Via Giovan Battista Perasso, 46 - 82100 Benevento%20Italia&t=k&z=19&ie=UTF8&iwloc=&output=embed"></iframe>
</div>


<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5 d-none">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>ANSI Formazione</h2>
                    <p>
                        Ansi Formazione è l’azienda di riferimento per tutte le persone che vogliono migliorare la propria condizione scolastica e professionale. Formata da un vero gruppo di persone, prima che di professionisti, cariche di energia positiva, persone che si sentono felici e creatrici di felicità così da garantire una costante contaminazione positiva dell’ambiente in cui vivono. Un’azienda che accoglie positivamente il cambiamento grazie alla grande capacità di adeguamento. Propositiva, audace, sperimentatrice, determinata e con un intuito molto sviluppato.
                    </p>
                    <p>
                        La nostra vision parte dalla differenza tra Istruzione e Formazione. La formazione, intesa come contributo e stimolo alla crescita evolutiva di una persona, persegue lo sviluppo di capacità e atteggiamenti cognitivi e lavorativi. Invece, l’istruzione è l’acquisizione di conoscenze ed alimentazione di processi cognitivi, ovvero apprendere una serie di nozioni relative ad una materia. Chi entra oggi nel mondo del lavoro deve avere entrambe le alternative. Deve poter scegliere tra una formazione di tipo accademica oppure di tipo professionalizzante. Diversamente, chi è già nel mondo del lavoro deve avere la possibilità di specializzarsi ed aumentare le proprie conoscenze e/o competenze. Ansi Formazione è tutto questo: formazione accademica, formazione professionale, certificazioni e servizi. Affidarsi ad Ansi Formazione vuol dire scegliere solo percorsi accreditati e riconosciuti dalle istituzioni competenti.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">dalla formazione alla professione</span>
                    <h2>Obiettivi formativi</h2>
                   <p>
                    Ansi Formazione è ente accreditato presso la Regione Campania ai sensi del D. D. N.131 del 28/06/2013 e ss.mm.ii. D.D. n. 4 del 28/12/2018 per l’erogazione di corsi di formazione e qualifiche regionali ai sensi della L.13/13 (già L. 845/78). Codice di Accreditamento 02095/08/11. Ansi Formazione con comunicazione del 14/07/2021 è stata inserita tra gli enti accreditati e qualificati dal MIM ai sensi della direttiva 170 del 2016. L’accreditamento ci riconosce come soggetti esterni al mondo della scuola che offrono formazione per i docenti delle scuole di ogni ordine e grado (usufruendo del bonus previsto dalla Carda del docente) e per chiunque voglia conseguite percorsi formativi riconosciuti dal MIM. Ansi Formazione rientra tra gli unici 20 enti in tutta Italia che hanno ottenuto l’accreditamento dall’ABAIT. Con delibera del consiglio direttivo del 31/03/2021 Ansi Formazione è ufficialmente entrata nei registri degli enti formatori autorizzati a curare l’organizzazione e l’erogazione di corsi che abilitano alla professione di tecnico del comportamento ABA. ABAIT è un’associazione accreditata dal Ministero della Salute e dell’Istruzione e che promuove il riconoscimento, la valorizzazione e lo sviluppo delle professioni nell’ambito dell’Analisi del Comportamento in tutte le sue accezioni. Ansi Formazione è società certificata ISO 9001, ovvero la certificazione internazionale che dimostra che un’azienda si impegna a fornire servizi e prodotti di qualità ai propri clienti. L’analisi che annualmente viene fatta conferma che Ansi Formazione è in grado di soddisfare le esigenze dei propri clienti nel rispettare gli standard ISO 9001 in termini di qualità e sicurezza. Un’offerta formativa a portata di tutti, senza limiti spazio/temporali a distanza e/o presenziale.
                   </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Informazioni</span>
                    <h2>Mettiti in contatto</h2>
                    <p>Ci piace ascoltare i lettori. Apprezziamo davvero che tu abbia dedicato del tempo per metterci in contatto.</p>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Dove siamo</h3>
                            <p>Via Giovan Battista Perasso, 46<br>82100 Benevento</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti</h3>
                            <p>Telefono: <a href="tel:+393923375799">(+39) 392-3375799</a></p>
                            <p><a href="mailto:formazioneregionale@ansiformazione.it">formazioneregionale@ansiformazione.it</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì - Venerdì<br>09:00 - 18:30</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2>Come possiamo aiutarti?</h2>
                    <p>L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3">Quale corso sei interessato?</h2>
                            <p>seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
